import { BlockchainNetwork } from '../constants.js'
import { getEvmV2Network } from '../blockchains/evmV2Networks.js'

export const getBlockchainUrlSegment = (blockchain: BlockchainNetwork): string => {
    // explorer.bitquery.io names EVM chains by network (/bsc/, /arbitrum/)
    const evmNetwork = getEvmV2Network(blockchain)
    if (evmNetwork) return evmNetwork.network

    // all blockchains from explorer, just in case
    switch (blockchain) {
        case BlockchainNetwork.bitcoin:
            return 'bitcoin'
        case BlockchainNetwork.cardano:
            return 'cardano'
        case BlockchainNetwork.tron:
            return 'tron'
        case BlockchainNetwork.solana:
            return 'solana'
        case BlockchainNetwork.algorand:
            return 'algorand'
        case BlockchainNetwork.stellar:
            return 'stellar'
        case BlockchainNetwork.ripple:
            return 'ripple'
        case BlockchainNetwork.hedera:
            return 'hedera'
        case BlockchainNetwork.tezos:
            return 'tezos'
        case BlockchainNetwork.filecoin:
            return 'filecoin'
        default:
            return blockchain
    }
}

export const getBitqueryExplorerUrl = (
    blockchain: BlockchainNetwork,
    type: 'address' | 'tx',
    value: string
): string => {
    const networkSegment = getBlockchainUrlSegment(blockchain)
    return `https://explorer.bitquery.io/${networkSegment}/${type}/${value}`
}

